import { Box } from "@chakra-ui/react";
import { FC } from "react";

export const FuncButton: FC<{
  onClick: () => void;
  children: string | number;
  disabled?: boolean;
}> = ({ onClick, children, disabled }) => (
  <Box
    as="button"
    padding="15px 20px"
    gap="10px"
    background="#55769D"
    fontWeight="700"
    fontSize="12px"
    color="#FFFFFF"
    _hover={{ opacity: 0.9 }}
    _active={{
      opacity: 0.7,
    }}
    _disabled={{
      opacity: 0.4,
    }}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </Box>
);
